// extracted by css-extract-rspack-plugin
export default {"textInput":"TextInputCell_textInput__C00xN","placeholderRow":"TextInputCell_placeholderRow__IMy0g","rightTextAlign":"TextInputCell_rightTextAlign__Gh2gM"};